import clsx from 'clsx'

import {
  budgetUSD,
  categories,
  requirementTimeline,
  strategySolutions,
  useCaseOptions
} from './fields'
import CheckboxField from './FormikFields/CheckboxField'
import RadioField from './FormikFields/RadioField'

/* styling */
import styles from './_.module.css'

interface Props {
  currentStep: number
  maxSteps: number
}

// forms
export const BudgetSelection = (props: Props) => {
  return (
    <section className={clsx('max-w-2xl  |  mx-auto', styles.animateBottom)}>
      <FormHeader
        currentStep={props.currentStep}
        maxStep={props.maxSteps}
        title="What is your estimated monthly marketing budget?"
      />

      <section className="flex gap-2 items-center justify-between | mb-4">
        <p className="text-paragraph-4 text-gray-60">
          Select an estimated range.
        </p>
      </section>

      <RadioField
        name="est_monthly_content_budget"
        options={budgetUSD}
        className="space-y-3"
      />
    </section>
  )
}

export const UseCaseSelection = (props: Props) => {
  return (
    <div className={clsx('max-w-2xl  |  mx-auto', styles.animateBottom)}>
      <FormHeader
        currentStep={props.currentStep}
        maxStep={props.maxSteps}
        title="What will you use our product for?"
      />

      <section className="mb-4">
        <p className="text-paragraph-4 text-gray-60">
          Select one or more use-cases
        </p>
      </section>

      <CheckboxField
        name="use_cases"
        options={useCaseOptions.map(option => ({
          label: option.key,
          value: option.value
        }))}
        className="grid grid-cols-1 gap-4 | mb-8"
      />
    </div>
  )
}

export const CategorySelection = (props: Props) => {
  return (
    <div className={clsx('max-w-2xl  |  mx-auto', styles.animateBottom)}>
      <FormHeader
        currentStep={props.currentStep}
        maxStep={props.maxSteps}
        title="What type of content would you like to create with us?"
      />

      <CheckboxField
        name="content_category"
        options={categories.map(i => ({ label: i.title, value: i.value }))}
        className="grid grid-cols-1 gap-4 | mb-8"
      />
    </div>
  )
}

export const TimelineSelection = (props: Props) => {
  return (
    <div className={clsx('max-w-2xl  |  mx-auto', styles.animateBottom)}>
      <FormHeader
        currentStep={props.currentStep}
        maxStep={props.maxSteps}
        title="How immediate is your content requirement?"
      />

      <section className="mb-4">
        <p className="text-paragraph-4 text-gray-60">Select one option</p>
      </section>

      <RadioField
        name="requirement_timeline"
        options={requirementTimeline}
        className="space-y-3"
      />
    </div>
  )
}

export const StrategySolutionSelection = (props: Props) => {
  return (
    <section className={clsx('max-w-2xl  |  mx-auto', styles.animateBottom)}>
      <FormHeader
        currentStep={props.currentStep}
        maxStep={props.maxSteps}
        title="Are you looking for content strategy solutions as well?"
      />

      {/* <section className="flex gap-2 items-center justify-between | mb-4">
        <p className="text-paragraph-4 text-gray-60">
          Select an estimated range.
        </p>
      </section> */}

      <RadioField
        name="strategy_solution"
        options={strategySolutions.map(i => ({ label: i, value: i }))}
        className="space-y-3"
      />
    </section>
  )
}

// form utility components
export const FormHeader = (props: {
  currentStep: number
  maxStep: number
  title: string
}) => {
  return (
    <header className="mb-6 sm:mb-8">
      <p className="text-small font-medium text-gray-50 | mb-2">
        Step {props.currentStep} of {props.maxStep}
      </p>
      <h1 className="h4-mobile font-medium">{props.title}</h1>
    </header>
  )
}
